import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CardListItemComponent } from './card-list-item/card-list-item.component';
import { CardListComponent } from './card-list.component';

@NgModule({
    declarations: [CardListComponent, CardListItemComponent],
    imports: [CommonModule],
    exports: [CardListComponent, CardListItemComponent],
})
export class CardListModule {}
